export default __webpack_public_path__ + "static/media/12.646e0438.png";